import configuration from "@intlayer/config/built";
import { getMultilingualUrls } from "./getMultilingualUrls.mjs";
const getLocalizedUrl = (url, currentLocale, locales = configuration.internationalization.locales, defaultLocale = configuration.internationalization.defaultLocale, prefixDefault = configuration.middleware.prefixDefault) => {
  const urlWithoutLocale = getMultilingualUrls(
    url,
    locales,
    defaultLocale,
    prefixDefault
  );
  return urlWithoutLocale[currentLocale];
};
export {
  getLocalizedUrl
};
//# sourceMappingURL=getLocalizedUrl.mjs.map